<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Oferta de Procedimentos</b>
						</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Unidade</label>
									<select-unidade @setUnidadeSelecionada="(unidadeSelecionada)=>{setUnidadeSelecionada(unidadeSelecionada)}"></select-unidade>
								</div>
							</div>

							<div class="col-md-6">
								<div class="form-group">
									<label for="">Profissional</label>
									<select-profissional @setProfissionalSelecionado="(profissionalSelecionado)=>{setProfissionalSelecionado(profissionalSelecionado)}"></select-profissional>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Grupo de Procedimento</label>
									<select name="grupo" class="form-control" v-model="grupoSelecionado" @change="setGrupoSelecionado()">
											<option value="">Selecione o grupo...</option>
											<option v-for="(grupo, index) in grupos" :value="grupo" :key="index">{{grupo.codigo}} - {{grupo.nome}}</option>
										</select>
								</div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
									<label for="">Sub-Grupo</label>
									<select-subgrupo @setSubgrupoSelecionado="(subgrupoSelecionado)=>{setSubgrupoSelecionado(subgrupoSelecionado)}"></select-subgrupo>
								</div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
									<label for="">Procedimento</label>
									<select-procedimento @setProcedimentoSelecionado="(procedimentoSelecionado)=>{setProcedimentoSelecionado(procedimentoSelecionado)}"></select-procedimento>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="data_de">Período</label>
									<data-filtro name="periodo" @operadorSelecionado="filtros.periodoOperador = $event" @dataSelecionada="filtros.periodo = $event" @data2Selecionada="filtros.periodo2 = $event"></data-filtro>
								</div>
							</div>

							<div class="col-md-3">
								<div class="form-group">
									<label for="">Agrupar por:</label>
									<select class='form-control' name='agrupamento' v-model="filtros.agrupamento">
														<option value="">Não agrupar</option>
														<option value="unidade">Unidade</option>
														<option value="procedimento">Procedimento</option>
														<option value="dia">Dia</option>
													</select>
								</div>
							</div>

							<div class="col-md-3">
								<div class="form-group">
									<label for="">Separar por:</label>
									<select class='form-control' name='separacao' v-model="filtros.separacao">
														<option value="">Nenhum</option>
														<option value="data">Data</option>
														<option value="dia">Dia da Semana</option>
														<option value="horario">Horários</option>
													</select>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12" style="text-align: right;">
								<div class="form-group">
									<input v-model="filtros.ignorar_prestador" style="margin-top: 0.5em;" type="checkbox"> Ignorar prestador
									<input v-model="filtros.ignorar_profissional" style="margin-left: 3.5em;" type="checkbox"> Ignorar profissional
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12">
								<h5><strong>Contadores a exibir</strong></h5>
							</div>
							<div class="col-sm-12">
								<table class="table table-bordered table-striped table-hover" style="font-size: 12px;">
									<thead>
										<tr>
											<th>#</th>
											<th><input type="checkbox" @click="toogleAll('disponivel')" v-model="filtros.contadores.disponivel.toogle"> Disponível</th>
											<th><input type="checkbox" @click="toogleAll('agendado')" v-model="filtros.contadores.agendado.toogle"> Agendado</th>
											<th><input type="checkbox" @click="toogleAll('bloqueado')" v-model="filtros.contadores.bloqueado.toogle"> Bloqueado</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><input type="checkbox" @click="toogleLinhaAll('primeira')" v-model="filtros.contadores.toogle.primeira"></td>
											<td><input type="checkbox" v-model="filtros.contadores.disponivel.primeira"> Primeira</td>
											<td><input type="checkbox" v-model="filtros.contadores.agendado.primeira"> Primeira</td>
											<td><input type="checkbox" v-model="filtros.contadores.bloqueado.primeira"> Primeira</td>
										</tr>
										<tr>
											<td><input type="checkbox" @click="toogleLinhaAll('retorno')" v-model="filtros.contadores.toogle.retorno"></td>
											<td><input type="checkbox" v-model="filtros.contadores.disponivel.retorno"> Retorno</td>
											<td><input type="checkbox" v-model="filtros.contadores.agendado.retorno"> Retorno</td>
											<td><input type="checkbox" v-model="filtros.contadores.bloqueado.retorno"> Retorno</td>
										</tr>
										<tr>
											<td><input type="checkbox" @click="toogleLinhaAll('local')" v-model="filtros.contadores.toogle.local"></td>
											<td><input type="checkbox" v-model="filtros.contadores.disponivel.local"> Local</td>
											<td><input type="checkbox" v-model="filtros.contadores.agendado.local"> Local</td>
											<td><input type="checkbox" v-model="filtros.contadores.bloqueado.local"> Local</td>
										</tr>
										<tr>
											<td><input type="checkbox" @click="toogleLinhaAll('total')" v-model="filtros.contadores.toogle.total"></td>
											<td><input type="checkbox" v-model="filtros.contadores.disponivel.total"> Total</td>
											<td><input type="checkbox" v-model="filtros.contadores.agendado.total"> Total</td>
											<td><input type="checkbox" v-model="filtros.contadores.bloqueado.total"> Total</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="box-footer text-right" ref='filtrar'>
							<button class="btn btn-info" :disabled="finalizado" @click.self.prevent="getPDF" v-if="pdf">Recarregar PDF <span class="fa fa-file-pdf-o" aria-hidden="true"></span></button>
							<button @click="getDataTable()" data-toggle="tooltip" title="Pesquisar Relatório de Oferta de Procedimentos" class="btn btn-primary" :disabled="finalizado"><span class="fa fa-search"></span> Pesquisar</button>
						</div>
						<div v-if="pdf">
							<embed type='application/pdf' :src="pdf" width='100%' :height="heigthPdf" />
						</div>
						<div class="row overflow" style="margin-top:15px;" v-if="!isEmpty(dataTable) && !pdf">
							<div class="col-md-12">
								<div class="table-responsive form-group">
									<table v-for="(itens, nome) in dataTable" :key="nome" class="table table-bordered table-striped">
										<thead>
											<tr>
												<th v-if="filtros.agrupamento == 'dia'" colspan="4"> {{nome | dataFormatada}}</th>
												<th v-if="filtros.agrupamento == 'procedimento'" colspan="4">Procedimento: {{ nome }}</th>
												<th v-if="filtros.agrupamento == 'unidade' && !filtros.ignorar_prestador" colspan="4">Unidade: {{ nome }}</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td colspan="4">
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr>
																<th rowspan="2" v-if="filtros.separacao == 'data'">Dia</th>
																<th rowspan="2" v-if="filtros.separacao == 'dia'">Dia da semana</th>
																<th rowspan="2" v-if="filtros.separacao == 'horario'">Horário</th>
																<th rowspan="2" v-if="!filtros.ignorar_prestador">Unidade</th>
																<th rowspan="2" v-if="!filtros.ignorar_profissional">Profissional</th>
																<th rowspan="2">Agenda</th>
																<th v-if="isVisible('disponivel')" :colspan="getColSpan('disponivel')" style="text-align: center; width: 10%">Disponível</th>
																<th v-if="isVisible('agendado')" :colspan="getColSpan('agendado')" style="text-align: center; width: 10%">Agendado</th>
																<th v-if="isVisible('bloqueado') && !itens[0].paciente" :colspan="getColSpan('bloqueado')" style="text-align: center; width: 10%">Bloqueado</th>
															</tr>
															<tr v-if="!itens[0].paciente">
																<th v-if="filtros.contadores.disponivel.primeira">P</th>
																<th v-if="filtros.contadores.disponivel.retorno">R</th>
																<th v-if="filtros.contadores.disponivel.local">L</th>
																<th v-if="filtros.contadores.disponivel.total">T</th>
																<th v-if="filtros.contadores.agendado.primeira">P</th>
																<th v-if="filtros.contadores.agendado.retorno">R</th>
																<th v-if="filtros.contadores.agendado.local">L</th>
																<th v-if="filtros.contadores.agendado.total">T</th>
																<th v-if="filtros.contadores.bloqueado.primeira">P</th>
																<th v-if="filtros.contadores.bloqueado.retorno">R</th>
																<th v-if="filtros.contadores.bloqueado.local">L</th>
																<th v-if="filtros.contadores.bloqueado.total">T</th>
															</tr>
															<tr v-else>
																<th colspan="4">Pacientes</th>
																<th colspan="4">Pacientes</th>

															</tr>
														</thead>
														<tbody v-if="!itens[0].paciente">
															<tr v-for="(item, index) in itens" :key="index">
																<td v-if="filtros.separacao == 'dia'">{{parseInt(item.dia_semana) | dia }}</td>
																<td v-if="filtros.separacao == 'data'">{{item.data_atendimento | dataFormatada}}</td>
																<td v-if="filtros.separacao == 'horario'">{{item.data_atendimento | dataFormatada }} das {{item.hora_inicial}} às {{item.hora_final}}</td>
																<td v-if="!filtros.ignorar_prestador">{{ item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo.contrato.unidade.nome }}</td>
																<td v-if="!filtros.ignorar_profissional">{{ item.profissional ? item.profissional.nome : "Agenda sem profissional"}}</td>
																<td>{{ item.contrato_procedimento ? item.contrato_procedimento.procedimento.codigo : item.contrato_subgrupo.subgrupo.codigo}} - {{ item.contrato_procedimento ? item.contrato_procedimento.procedimento.nome : item.contrato_subgrupo.subgrupo.nome }}</td>
																<td v-if="filtros.contadores.disponivel.primeira" style="text-align: right;">{{ item.quantidade_primeira }}</td>
																<td v-if="filtros.contadores.disponivel.retorno" style="text-align: right;">{{ item.quantidade_retorno ? item.quantidade_retorno : "0"}}</td>
																<td v-if="filtros.contadores.disponivel.local" style="text-align: right;">{{ item.quantidade_local }}</td>
																<td v-if="filtros.contadores.disponivel.total" style="text-align: right;"><strong>{{ item.quantidade_total }}</strong></td>
																<td v-if="filtros.contadores.agendado.primeira" style="text-align: right;">{{ item.quantidade_primeira_agendada }}</td>
																<td v-if="filtros.contadores.agendado.retorno" style="text-align: right;">{{ item.quantidade_retorno_agendada }}</td>
																<td v-if="filtros.contadores.agendado.local" style="text-align: right;">{{ item.quantidade_local_agendada }}</td>
																<td v-if="filtros.contadores.agendado.total" style="text-align: right;"><strong>{{ item.quantidade_total_agendada }}</strong></td>
																<td v-if="filtros.contadores.bloqueado.primeira" style="text-align: right;">{{item.quantidade_primeira_bloqueada == null ? 0 : item.quantidade_primeira_bloqueada}}</td>
																<td v-if="filtros.contadores.bloqueado.retorno" style="text-align: right;">{{ item.quantidade_retorno_bloqueada == null ? 0 : item.quantidade_retorno_bloqueada }}</td>
																<td v-if="filtros.contadores.bloqueado.local" style="text-align: right;">{{ item.quantidade_local_bloqueada == null ? 0 : item.quantidade_local_bloqueada }}</td>
																<td v-if="filtros.contadores.bloqueado.total" style="text-align: right;"><strong>{{ item.quantidade_total_bloqueada == null ? 0 : item.quantidade_total_bloqueada }}</strong></td>
															</tr>
														</tbody>
														<tbody v-else>
															<tr v-for="(item, index) in itens" :key="index">
																<td v-if="filtros.separacao == 'dia'">{{parseInt(item.dia_semana) | dia }}</td>
																<td v-if="filtros.separacao == 'data'">{{item.data_atendimento | dataFormatada}}</td>
																<td v-if="filtros.separacao == 'horario'">{{item.data_atendimento | dataFormatada }} das {{item.hora_inicial}} às {{item.hora_final}}</td>
																<td v-if="!filtros.ignorar_prestador">{{ item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo.contrato.unidade.nome }}</td>
																<td v-if="!filtros.ignorar_profissional">{{ item.profissional ? item.profissional.nome : "Agenda sem profissional"}}</td>
																<td>{{ item.contrato_procedimento ? item.contrato_procedimento.procedimento.codigo : item.contrato_subgrupo.subgrupo.codigo}} - {{ item.contrato_procedimento ? item.contrato_procedimento.procedimento.nome : item.contrato_subgrupo.subgrupo.nome }}</td>
																<td colspan="4" style="text-align: right;">{{ item.quantidade_paciente }}</td>
																<td colspan="4" style="text-align: right;">{{ item.quantidade_paciente_agendada }}</td>

															</tr>
														</tbody>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<br>
						<div class="row" v-if="!isEmpty(dataTable)">
							<!-- <div class="col-sm-4">
														Mostrando unidade {{ this.dataTable.from }} de {{ this.dataTable.total }}.
													</div>
													<div class="col-sm-6" style="text-align:right">
														<laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
															<span slot="prev-nav">&lt; Anterior</span>
															<span slot="next-nav">Próximo &gt;</span>
														</laravue-pagination>
													</div> -->
							<div class="col-sm-offset-10 col-sm-2 text-right">
								<button class="btn btn-info pdf" v-show="!pdf" :disabled="finalizado" @click.self.prevent="getPDF"><span class="fa fa-file-pdf-o" aria-hidden="true"></span> PDF</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http
	import selectUnidade from "@/components/cadastros/unidades/selectUnidade";
	import selectProfissional from "@/components/cadastros/profissionais/selectProfissional";
	import selectProcedimento from "@/components/cadastros/procedimentos/selectProcedimento";
	import selectSubgrupo from "@/components/cadastros/procedimentos/subgrupos/selectSubgrupo";
	import DataFiltro from "@/components/componentes/DataFiltro";
	import _ from 'lodash'

	export default {
		data: () => ({
			pdf: null,
			heigthPdf: 900,
			finalizado: false,
			grupos: [],
			grupoSelecionado: '',
			filtros: {
				unidade_id: null,
				unidade: '',
				profissional_id: null,
				profissional: '',
				procedimento_id: null,
				procedimento: '',
				grupo_id: '',
				grupo: '',
				subgrupo_id: null,
				subgrupo: '',
				periodo: null,
				periodo2: null,
				periodoOperador: null,
				agrupamento: 'procedimento',
				separacao: '',
				ignorar_profissional: false,
				ignorar_prestador: false,
				contadores: {
					toogle: {
						primeira: false,
						retorno: false,
						local: false,
						total: false,
					},
					disponivel: {
						toogle: true,
						primeira: true,
						retorno: true,
						local: true,
						total: true
					},
					agendado: {
						toogle: false,
						primeira: false,
						retorno: false,
						local: false,
						total: false
					},
					bloqueado: {
						toogle: false,
						primeira: false,
						retorno: false,
						local: false,
						total: false
					},
				}
			},

			dataTable: {},
		}),
		mounted() {
			this.getGrupos();
		},
		methods: {
			getDataTable() {
				// console.log(this.filtros);
				this.finalizado = true;
				this.pdf = null;

				this.$store.commit('TOGGLE_LOADING');
				let config = this.$store.getters.getHeaderAuth;
				config.params = this.filtros;

				axios.get(`${this.$store.state.serverURI}/api/relatorios/ofertas`, config)
					.then(response => {
						console.log(response.data);
						this.dataTable = response.data;
						for (const key in this.dataTable) {
							if (this.dataTable[key] && this.filtros.separacao == 'data') {
								this.dataTable[key] = _.orderBy(this.dataTable[key], ['data_atendimento'], ['asc']);
							}
							if (this.dataTable[key] && this.filtros.separacao == 'horario') {
								this.dataTable[key] = _.orderBy(this.dataTable[key], ['data_atendimento', 'hora_inicial', 'hora_final'], ['asc', 'asc', 'asc']);
							}
							if (this.dataTable[key] && this.filtros.separacao == 'dia') {
								this.dataTable[key] = _.orderBy(this.dataTable[key], ['dia_semana'], ['asc']);
							}
						}
						this.$store.commit('TOGGLE_LOADING');
						this.finalizado = false;
					}).catch((error) => {
						this.$store.commit('throwException', error);
						this.finalizado = false;
					});
			},
			getGrupos() {
				axios
					.get(`${this.$store.state.serverURI}/api/cadastros/grupos-procedimento/getAll`,
						this.$store.getters.getHeaderAuth
					)
					.then(response => {
						this.grupos = response.data;
					})
					.catch(error => {
						console.log(error);
					});
			},
			setUnidadeSelecionada(unidadeSelecionada) {
				this.filtros.unidade_id = unidadeSelecionada.id;
				this.filtros.unidade = unidadeSelecionada.nome;
			},
			setProfissionalSelecionado(profissionalSelecionado) {
				this.filtros.profissional_id = profissionalSelecionado.id;
				this.filtros.profissional = profissionalSelecionado.nome;
			},
			setSubgrupoSelecionado(subgrupoSelecionado) {
				this.filtros.subgrupo_id = subgrupoSelecionado.id;
				this.filtros.subgrupo = subgrupoSelecionado.nome;
			},
			setProcedimentoSelecionado(procedimentoSelecionado) {
				this.filtros.procedimento_id = procedimentoSelecionado.id;
				this.filtros.procedimento = procedimentoSelecionado.nome;
			},
			setGrupoSelecionado() {
				this.filtros.grupo_id = this.grupoSelecionado.id;
				this.filtros.grupo = this.grupoSelecionado.nome;
			},
			isVisible(contador) {
				var qtdSelecionado = this.getColSpan(contador);
				if (qtdSelecionado > 0) {
					return true;
				}

				return false;
			},
			getColSpan(contador) {
				var colspan = 0;
				if (this.filtros.contadores[contador].primeira) {
					colspan++;
				}
				if (this.filtros.contadores[contador].retorno) {
					colspan++;
				}
				if (this.filtros.contadores[contador].local) {
					colspan++;
				}
				if (this.filtros.contadores[contador].total) {
					colspan++;
				}

				return colspan;
			},
			toogleAll(contador) {
				if (this.filtros.contadores[contador].toogle) {
					this.filtros.contadores[contador].primeira = false;
					this.filtros.contadores[contador].retorno = false;
					this.filtros.contadores[contador].local = false;
					this.filtros.contadores[contador].total = false;
					this.filtros.contadores[contador].toogle = false;
				} else {
					this.filtros.contadores[contador].primeira = true;
					this.filtros.contadores[contador].retorno = true;
					this.filtros.contadores[contador].local = true;
					this.filtros.contadores[contador].total = true;
					this.filtros.contadores[contador].toogle = true;
				}
			},
			toogleLinhaAll(linha) {
				if (this.filtros.contadores.toogle[linha]) {
					this.filtros.contadores.disponivel[linha] = false;
					this.filtros.contadores.agendado[linha] = false;
					this.filtros.contadores.bloqueado[linha] = false;
				} else {
					this.filtros.contadores.disponivel[linha] = true;
					this.filtros.contadores.agendado[linha] = true;
					this.filtros.contadores.bloqueado[linha] = true;
				}
			},
			isEmpty(objeto) {
				return Object.values(objeto).every(valor => valor === '');
			},
			getPDF() {
				this.finalizado = true;
				this.$store.commit('TOGGLE_LOADING');
				axios.post(`${this.$store.state.serverURI}/api/relatorios/ofertasImprimir`, this.filtros, this.$store.getters.getHeaderAuthFile)
					.then(response => {
						this.$store.commit('TOGGLE_LOADING');
						const file = new Blob([response.data], {
							type: 'application/pdf'
						});
						const fileURL = window.URL.createObjectURL(file);
						this.pdf = fileURL;
						let self = this;
						this.heigthPdf = window.innerHeight - 65;
						console.log(window.innerHeight)
						setTimeout(function() {
							self.$refs.filtrar.scrollIntoView();
						}, 300);
						this.finalizado = false;
					}).catch((error) => {
						this.$store.commit('throwException', error);
						this.finalizado = false;
					});
			}
		},
		components: {
			selectUnidade,
			selectProfissional,
			selectProcedimento,
			selectSubgrupo,
			DataFiltro,
		}

	}
</script>

<style>
	.overflow {
		overflow: auto;
		height: 600px;
	}
</style>



// WEBPACK FOOTER //
// index.vue?0d2ab3cb